export function groupByMonth(data, year) {
  const result = {
    data: new Array(12).fill(0),
    dates: new Array(12).fill(null),
  }

  for (let i = 0; i < 12; i++) {
    result.dates[i] = i + 1
  }

  data?.forEach((obj) => {
    const date = new Date(obj.data)
    if (date.getFullYear() === year) {
      result.data[date.getMonth()] += Number(obj.valor)
    }
  })

  console.log(1, result)
  return result
}
